import { useSelector } from 'react-redux';
import { useCallback } from 'react';

import { selectServicePageInfo } from '../../../selectors/servicePageInfo';
import { createCianAnalyticsPageViewObject } from '../../../utils/createCianAnalyticsPageViewObject';
import { trackEvent } from '../../../utils/tracking';

export interface IUseSideBarTrackingResult {
  trackBackToPage: () => void;
}

export const useSideBarTracking = (): IUseSideBarTrackingResult => {
  const servicePageInfo = useSelector(selectServicePageInfo);

  const trackBackToPage = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'to_service',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  return {
    trackBackToPage,
  };
};
